module.exports = __webpack_public_path__ + "static/assets/2cb46ac1ee424b233d499f4de497a493.svg";